import { createAction, props } from '@ngrx/store';
import { activeDeactiveUserPayload, usersListPayload } from './users.model';

export const fetchUsersList = createAction('[Data] Fetch Users List', props<{ payload: usersListPayload }>());
export const fetchUsersListSuccess = createAction('[Data] Fetch Users List Success', props<{ response: any }>());
export const fetchUsersListFailure = createAction('[Data] Fetch Users List Failure', props<{ error: string }>());

export const activeDeactiveUser = createAction('[Data] Active Deactive User', props<{ payload: activeDeactiveUserPayload }>());
export const activeDeactiveUserSuccess = createAction('[Data] Active Deactive User Success', props<{ response: any }>());
export const activeDeactiveUserFailure = createAction('[Data] Active Deactive User Failure', props<{ error: string }>());
